// Typelizer digest 133c7346213f459915e8a19a4b61e2d7
//
// DO NOT MODIFY: This file was automatically generated by Typelizer.
import type { RouteDefinition, RouteOptions } from '../runtime'
import { buildUrl } from '../runtime'

export default {
  /** POST /admin/productions/:production_id/publication */
  create: (
    params: { productionId: string | number } | string | number,
    options?: RouteOptions,
  ): RouteDefinition<'post'> => ({
    url: buildUrl('/admin/productions/:production_id/publication', params, options),
    method: 'post',
  }),
}
